import React, { useState, useRef } from "react";
import { useNotaire } from "../../context/NotaireContext";
import { Field, Label } from "../../components/catalyst/fieldset";
import { toast } from "react-toastify";
import { Editor } from "@tinymce/tinymce-react";

function PanelPresentation() {
  const context = useNotaire();
  const editorRef = useRef(null);

  const [presentation, setPresentation] = useState(context.infoEtude.presentation || "");
  const [loading, setLoading] = useState(false);

  const onEditorChange = (content) => {
    setPresentation(content);
  };

  const handlePresentationSubmit = async (e) => {
    e.preventDefault();

    const content = editorRef.current?.getContent() || presentation;

    if (!content || content.length < 5) {
      toast.error("La présentation est trop courte.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `https://api.airtable.com/v0/appD48APNaGA4GN0B/etudes/${context.infoEtude.id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fields: { presentation: content },
          }),
        }
      );

      if (response.ok) {
        toast.success("Présentation mise à jour !");
      } else {
        const errText = await response.text();
        console.error("Erreur Airtable:", errText);
        toast.error("Erreur lors de la mise à jour de la présentation.");
      }
    } catch (err) {
      console.error("Erreur réseau:", err);
      toast.error("❌ Erreur réseau");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded shadow mt-8">
      <form onSubmit={handlePresentationSubmit} className="space-y-4">
        <Field>
          <Label>Présentation</Label>
          <Editor
            apiKey="0x5idds7oty0zma9ptz4xam6twjys01axtli500yntt5lr1c"
            onEditorChange={onEditorChange}
            initialValue={context.infoEtude.presentation}
            value={presentation}
            onInit={(evt, editor) => (editorRef.current = editor)}
            init={{
              height: 500,
              menubar: false,
              plugins: [
                "mentions advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media paste code help wordcount",
              ],
              toolbar:
                "undo redo | formatselect | bold italic backcolor | alignleft aligncenter " +
                "alignright alignjustify | bullist numlist outdent indent | removeformat | emoticons | help",
              content_style: "body { font-family:Arial,sans-serif; font-size:14px }",
              emoticons_append: {
                custom_mind_explode: {
                  keywords: ["brain", "mind", "explode", "blown"],
                  char: "🤯",
                },
              },
            }}
          />
        </Field>

        <button
          type="submit"
          className="btn-primary mt-4"
          disabled={loading}
        >
          {loading ? "Mise à jour..." : "Modifier la présentation"}
        </button>
      </form>
    </div>
  );
}

export default PanelPresentation;